export default {
  id: 96,
  title: 'Target #96 - Mandala',
  url: 'https://cssbattle.dev/play/96',
  colors: ['#6592CF', '#243D83'],
  solution:
    '<a><p a><p b><p c><p d><style>a,p{border-radius:9in}[a],[d]{left:115}body{background:#243d83}a,p{position:fixed}a{background:#6592cf;top:50;left:100;width:200;height:200}p{width:130;height:130;border:20px solid #243d83}[a]{bottom:124}[b]{top:49;left:40}[c]{top:49;right:40}[d]{top:124}</style>',
}
